import { onClickOutsideOf } from '@/js/utils'
import * as focusTrap from 'focus-trap'

class HeaderDrawer extends HTMLElement {
    static ELEMENT_NAME = 'header-drawer'

    static SELECTORS = {
        triggerButtons: '[data-header-drawer-trigger]'
    }

    static CLASSES = {
        isOpen: 'is-open'
    }

    $elements = {
        triggerButtons: null
    }

    isOpen = false
    focusTrap = null
    outsideClickHandler = null

    constructor() {
        super()

        this.$elements.triggerButtons = document.querySelectorAll(HeaderDrawer.SELECTORS.triggerButtons)

        this.focusTrap = focusTrap.createFocusTrap(this, {
            onDeactivate: () => this.close()
        })

        this.$elements.triggerButtons.forEach(button => button.addEventListener('click', this.handleTriggerButtonClick.bind(this)))
    }

    /**
     * FUNCTIONS
     */

    open() {
        this.isOpen = true
        this.classList.add(HeaderDrawer.CLASSES.isOpen)
        this.focusTrap.activate()

        // close the menu, if its open
        const mainMenu = document.querySelector('main-navigation')
        mainMenu.toggleMenu(false)

        window.setTimeout(() => {
            this.outsideClickHandler = onClickOutsideOf(this, () => this.close())
            this.outsideClickHandler.add()
        }, 200)
    }

    close() {
        this.isOpen = false
        this.classList.remove(HeaderDrawer.CLASSES.isOpen)
        this.focusTrap.deactivate()

        if (this.outsideClickHandler) {
            this.outsideClickHandler.remove();
            this.outsideClickHandler = null
        }
    }

    toggle() {
        this.isOpen ? this.close() : this.open()
    }

    /**
     * EVENTS
     */

    handleTriggerButtonClick(e) {
        this.toggle();
    }
}

customElements.define(HeaderDrawer.ELEMENT_NAME, HeaderDrawer);